import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {DocumentId} from '../models/document.modal';
import {Observable} from 'rxjs';
import {API_PATH} from '../../../shared/constants';
import {PolicyQuery} from '../../../policy/state/policy.query';
import {QuestionFlowSessionQuery} from '../../../shared/questions/state/question-flow-session.query';

const headers = new HttpHeaders()
  .set('content-type', 'application/json')
  .set('Access-Control-Allow-Origin', '*')
  .set('Accept', 'application/json');

@Injectable({
  providedIn: 'root'
})

export class DocumentService {

  constructor(
    private httpClient: HttpClient,
    private policyQuery: PolicyQuery,
    private questionFlowSessionQuery: QuestionFlowSessionQuery
  ) { 
    
  }
 getIP(): Observable<any> {
   return this.httpClient.get('https://assets.everything.insure/ip'); //workaround for now.

 }
  getDocument(documentId: DocumentId,ipAddress): Observable<any> {
    let sessionId = this.policyQuery.getEntity(this.policyQuery.getActiveId())?.session_id;
    if (!sessionId) {
      sessionId = this.questionFlowSessionQuery.getValue()?.session_id;
    }
    const referrerId = 2; // always 2 for central
    const encrypt = 0;
    return this.httpClient.get(`${API_PATH.GET_DOCUMENT}/${sessionId}/${documentId}/${referrerId}/${ipAddress}/${encrypt}`, {headers});
  }

  getDocuments(session_id: string): Observable<any> {
    const sessionId = this.policyQuery.getEntity(this.policyQuery.getActiveId())?.session_id;
    return this.httpClient.get(`${API_PATH.GET_DOCUMENTS}/${sessionId}`, {headers});
  }

}
